import { CurrencyIcon } from "../../../../Components/Atoms/CurrencyIcon";
import {
  getPaymentMethodCountry,
  getPaymentMethodCurrency,
  PAYMENT_RAILS,
} from "../constants";

export const OriginPaymentMethodOption = ({ method }) => {
  if (!method) return null;

  const country = getPaymentMethodCountry(method);
  const currency = getPaymentMethodCurrency(method);
  const flagAsset = currency?.id ?? country?.currencyId;
  const railLabel = PAYMENT_RAILS[method.railId]?.label ?? method.label;

  return (
    <>
      {flagAsset ? <CurrencyIcon asset={flagAsset} /> : null}
      <span className="min-w-0 truncate text-brand-dark">
        {country ? (
          <>
            <span className="font-semibold">{country.label}</span>
            {currency ? (
              <span className="font-medium text-gray-500 dark:text-gray-400"> · {currency.code}</span>
            ) : null}
            <span className="font-medium text-gray-500 dark:text-gray-400"> · {railLabel}</span>
          </>
        ) : (
          <span className="font-semibold">{railLabel}</span>
        )}
      </span>
    </>
  );
};
